import React from "react";
import Home from "./pages/Home/Home";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Nieuwpoort from "./pages/Nieuwpoort/Nieuwpoort";
import Contact from "./pages/Contact/Contact";
import PageNotFound from "./pages/PageNotFound";

function App() {
  return (
    <Router>
      <Routes>
        <>Home</>
        <Route exact path="/" element={<Home />} />
        
        <>Activiteiten</>
        <Route path="/activiteiten" element={<Nieuwpoort />} />
        
        <>Contact</>
        <Route path="/contact" element={<Contact />} />

        <>Not found</>
        <Route path="/*" element={<PageNotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
